/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeFormat } from './TimeFormat';
import {
    TimeFormatFromJSON,
    TimeFormatFromJSONTyped,
    TimeFormatToJSON,
    TimeFormatToJSONTyped,
} from './TimeFormat';
import type { WindowsTimezone } from './WindowsTimezone';
import {
    WindowsTimezoneFromJSON,
    WindowsTimezoneFromJSONTyped,
    WindowsTimezoneToJSON,
    WindowsTimezoneToJSONTyped,
} from './WindowsTimezone';
import type { Language } from './Language';
import {
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
    LanguageToJSONTyped,
} from './Language';
import type { DateFormat } from './DateFormat';
import {
    DateFormatFromJSON,
    DateFormatFromJSONTyped,
    DateFormatToJSON,
    DateFormatToJSONTyped,
} from './DateFormat';
import type { Mode } from './Mode';
import {
    ModeFromJSON,
    ModeFromJSONTyped,
    ModeToJSON,
    ModeToJSONTyped,
} from './Mode';
import type { LengthUnit } from './LengthUnit';
import {
    LengthUnitFromJSON,
    LengthUnitFromJSONTyped,
    LengthUnitToJSON,
    LengthUnitToJSONTyped,
} from './LengthUnit';

/**
 * 
 * @export
 * @interface PublicSettingUpdate
 */
export interface PublicSettingUpdate {
    /**
     * 
     * @type {string}
     * @memberof PublicSettingUpdate
     */
    instanceName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PublicSettingUpdate
     */
    logoId?: string | null;
    /**
     * 
     * @type {Language}
     * @memberof PublicSettingUpdate
     */
    defaultLanguage?: Language | null;
    /**
     * 
     * @type {WindowsTimezone}
     * @memberof PublicSettingUpdate
     */
    defaultTimezone?: WindowsTimezone | null;
    /**
     * 
     * @type {DateFormat}
     * @memberof PublicSettingUpdate
     */
    defaultDateFormat?: DateFormat | null;
    /**
     * 
     * @type {TimeFormat}
     * @memberof PublicSettingUpdate
     */
    defaultTimeFormat?: TimeFormat | null;
    /**
     * 
     * @type {LengthUnit}
     * @memberof PublicSettingUpdate
     */
    defaultLengthUnit?: LengthUnit | null;
    /**
     * 
     * @type {Mode}
     * @memberof PublicSettingUpdate
     */
    mode?: Mode | null;
}



/**
 * Check if a given object implements the PublicSettingUpdate interface.
 */
export function instanceOfPublicSettingUpdate(value: object): value is PublicSettingUpdate {
    return true;
}

export function PublicSettingUpdateFromJSON(json: any): PublicSettingUpdate {
    return PublicSettingUpdateFromJSONTyped(json, false);
}

export function PublicSettingUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicSettingUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'instanceName': json['instanceName'] == null ? undefined : json['instanceName'],
        'logoId': json['logoId'] == null ? undefined : json['logoId'],
        'defaultLanguage': json['defaultLanguage'] == null ? undefined : LanguageFromJSON(json['defaultLanguage']),
        'defaultTimezone': json['defaultTimezone'] == null ? undefined : WindowsTimezoneFromJSON(json['defaultTimezone']),
        'defaultDateFormat': json['defaultDateFormat'] == null ? undefined : DateFormatFromJSON(json['defaultDateFormat']),
        'defaultTimeFormat': json['defaultTimeFormat'] == null ? undefined : TimeFormatFromJSON(json['defaultTimeFormat']),
        'defaultLengthUnit': json['defaultLengthUnit'] == null ? undefined : LengthUnitFromJSON(json['defaultLengthUnit']),
        'mode': json['mode'] == null ? undefined : ModeFromJSON(json['mode']),
    };
}

export function PublicSettingUpdateToJSON(json: any): PublicSettingUpdate {
    return PublicSettingUpdateToJSONTyped(json, false);
}

export function PublicSettingUpdateToJSONTyped(value?: PublicSettingUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instanceName': value['instanceName'],
        'logoId': value['logoId'],
        'defaultLanguage': LanguageToJSON(value['defaultLanguage']),
        'defaultTimezone': WindowsTimezoneToJSON(value['defaultTimezone']),
        'defaultDateFormat': DateFormatToJSON(value['defaultDateFormat']),
        'defaultTimeFormat': TimeFormatToJSON(value['defaultTimeFormat']),
        'defaultLengthUnit': LengthUnitToJSON(value['defaultLengthUnit']),
        'mode': ModeToJSON(value['mode']),
    };
}

